import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import StorePage from "./pages/StorePage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/shop/demo" replace />} />
        <Route path="/shop/:slug" element={<StorePage />} />
        <Route path="*" element={<div className="p-6">Not found</div>} />
      </Routes>
    </BrowserRouter>
  );
}
